export default [

    { label:'费用总额:',spanRows:8,type:'input',modelValue:'receivedMoney'},
    { label:'账户余额:',spanRows:8,type:'input',modelValue:'accountNumber'},
    { label:'当前票号:',spanRows:8,type:'input',modelValue:'currentNumber'},
    { label:'挂账余额:',spanRows:8,type:'input',modelValue:'oweNumber'},
    { label:'备注:',spanRows:24,type:'input',modelValue:'remake'},
    { label:'病原费别:',spanRows:8,type:'select',modelValue:'feeType',op:'prhCostOption'},
    { label:'现金支付:',spanRows:8,type:'input',modelValue:'MoneyPay'},
    { label:'医保支付:',spanRows:8,type:'input',modelValue:'healthCarePay'},
    { label:'健康卡付:',spanRows:8,type:'input',modelValue:'fitnessCardpay'},
    { label:'银联支付:',spanRows:8,type:'input',modelValue:'unionPay'},
    { label:'挂账支付:',spanRows:8,type:'input',modelValue:'owePay'},
    { label:'支付方式:',spanRows:8,type:'select',modelValue:'payType',op:'payTypeOption'},
    { label:'优惠金额:',spanRows:8,type:'input',modelValue:'discountsNumber'},
    { label:'应收现金:',spanRows:8,type:'input',modelValue:'receivableNumber'},
    { label:'收到现金:',spanRows:8,type:'input',modelValue:'receiveNumber'},
    { label:'找零金额:',spanRows:8,type:'input',modelValue:'changeNumber'},

]